import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { useDispatch, connect } from "react-redux";
import { withRouter } from "react-router-dom";

import loginPage from "./loginPage";

import OtpInput from "react-otp-input";
import EditIcon from "@mui/icons-material/Edit";

import { useHistory } from "react-router-dom";
import { Formik } from "formik";
import { CheckOtpRequest, CheckOtpResponse } from "../../models/security.model";
import * as Yup from "yup";
import { useMutation, useQueryClient } from "react-query";
import { MOBILE_NUMBER, REFERENCE_NUMBER } from "../../config/cacheKey";
import { CheckOtp, sendOtp } from "../../services/security.service";
import { setJwtToken } from "../../services/auth.service";
import { Button, CircularProgress, Typography } from "@material-ui/core";
import { CountdownCmp } from "../../components/countdown/Countdown";
import LoginPage from "./loginPage";
import { ApiResultModel } from "../../models/common.model";
import { toast } from "react-toastify";
const _otp = () => {
  const [otp, setOtp] = React.useState("");
  const [isBtnEnterClicked, setIsBtnEnterClicked] = React.useState<boolean>();
  const otpValid = Yup.object({
    otpNumber: Yup.string().required(),
  });
  const queryClient = useQueryClient();
  const history = useHistory();
  const mobileNumber = queryClient.getQueryData<string>(MOBILE_NUMBER);
  const checkOptMutation = useMutation(CheckOtp, {
    onSuccess: (data: ApiResultModel<CheckOtpResponse>) => {
      if (data.isSuccess) {
        setJwtToken(data.data.jwt);
        history.push("/welcome");
        // history.push("/loan/loan-list");
      } else if (!data.isSuccess && isBtnEnterClicked) {
        data.messages.map((message: any) => {
          toast.error(message.message);
        });
      }
    },
  });

  useEffect(() => {
    setIsBtnEnterClicked(false);
    if (otp.length === 5) {
      handleBtnClick(initValue);
    }
  }, [otp]);

  const sendOptMutation = useMutation(sendOtp, {
    onSuccess: (data: string) => {
      if (data) {
        queryClient.setQueryData(REFERENCE_NUMBER, data);
      }
    },
  });
  function handleOnCompletedClick() {
    sendOptMutation.mutate({ mobileNumber });
  }
  function handleBtnClick(values: any) {
    values.referenceNumber = queryClient.getQueryData(REFERENCE_NUMBER);
    values.otp = otp;
    checkOptMutation.mutate(values);
  }

  const mobileHandler = () => {
    history.push("/login");
  };
  const flag = true;
  const initValue = new CheckOtpRequest();
  initValue.otp = "";

  return (
    <>
      <Formik
        initialValues={initValue}
        onSubmit={(values) => {
          values.referenceNumber = queryClient.getQueryData(REFERENCE_NUMBER);
          values.otp = otp;
          // checkOptMutation.mutate(values);

          setIsBtnEnterClicked(true);
          handleBtnClick(values);
        }}
      >
        {({ handleSubmit, handleChange, values }) => (
          <form onSubmit={handleSubmit}>
            <div>
              <div
                className="iranSans-font textCenter  fontWeight colorBase  textFont20"
                style={{ marginTop: "3vh", marginBottom: "1vh" }}
              >
                <EditIcon
                  className="cursorPointer"
                  style={{ color: "#b6c88a" }}
                  onClick={mobileHandler}
                />
                <p>{mobileNumber}</p>
              </div>

              <Typography
                variant="h6"
                className=" textCenter  fontWeight colorBase  textFont16 "
                style={{ marginTop: "1vh" }}
              >
                کد فعالسازی را وارد کنید
              </Typography>

              <div
                dir="ltr"
                className=" classCenter container "
                style={{ marginTop: "9vh" }}
              >
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  focusStyle={{ borderBottom: "3px solid #b6b5b5" }}
                  shouldAutoFocus={true}
                  numInputs={5}
                  separator={<span></span>}
                  isInputNum={true}
                  inputStyle={{
                    width: "30px",
                    height: "35px",
                    margin: ".1px ",
                    fontSize: "24px",
                    dir: "ltr !important",
                    border: "none",
                    outline: "none",
                    borderBottom: "3px solid #1D4A87",
                    marginRight: "0px",
                    color: "#043D5D",
                    name: "otp",
                    id: "otp",
                  }}
                  className=" opt-input classCenter"
                />
              </div>
              <Typography
                className=" textCenter iranSans-font  colorOk textFont15 fontWeight "
                style={{ marginTop: "5vh" }}
              >
                <CountdownCmp
                  countDownValue={120000}
                  onCompletedClick={() => handleOnCompletedClick()}
                  btnName="ارسال کد"
                />
              </Typography>
            </div>

            <Button
              style={{ marginTop: "5vh" }}
              onClick={undefined}
              fullWidth
              type="submit"
              variant="contained"
              className="btnForm SuccessDefault Vazirmatn"
            >
              ورود
            </Button>
          </form>
        )}
      </Formik>
    </>
  );
};

export default function Otp() {
  const childForm = <_otp />;
  const queryClient = useQueryClient();
  queryClient.setQueryData("GetCartables", null);
  queryClient.setQueryData("GetCartablesReg", null);
  queryClient.setQueryData("table_filter", null);
  return (
    <Box sx={{ flexGrow: 2, overflow: "hidden", px: 3 }}>
      <LoginPage childForm={childForm} />
    </Box>
  );
}
